/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import ReactApexChart from "react-apexcharts";
/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'

export class StaffContributionChart extends Component {
    static displayName = StaffContributionChart.name;

    constructor(props) {
        super(props);

        const self = this;

        this.state = {
            mode: Constants.MODE_LOADING,
            options: {
                plotOptions: {
                    bar: {
                        barHeight: '40%',
                        distributed: true,
                        horizontal: true,
                        dataLabels: {
                            position: 'bottom'
                        },
                    }
                },
                chart: {
                    toolbar: {
                        show: false,
                    }
                },
                responsive: [{
                    breakpoint: 1500,
                    options: {
                        chart: {
                            width: 320,
                            height: 220
                        },
                        legend: {
                            position: 'bottom'
                        },
                        datalabels: {
                            offsetY: -10,
                            offsetX: 10,
                        }
                    }
                }],
                grid: {
                    show: true,
                    padding: {
                        top: 0,
                        bottom: 0,
                    },  
                },
                colors: ['#6dbc75', '#663399', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e', '#f48024', '#69d2e7'],
                dataLabels: {
                    enabled: true,
                    style: {
                        colors: ['#404040'],
                        fontWeight: 100
                    },
                    formatter: function (val, opt) {
                        return self.state.options.xaxis.categories[opt.dataPointIndex] + ":  " + val.toFixed(2) + '%'
                    },
                    textAnchor : 'start',
                    offsetY: -12,
                    offsetX: -12,
                    dropShadow: {
                        enabled: false
                    }
                },
                legend: {
                    show: false,
                    fontWeight: 100
                },
                stroke: {
                    width: 0
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    categories: []
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                title: {
                    text: 'Staff Contribution',
                    align: 'left',
                    margin: 20,
                    floating: true,
                    style: {
                        fontSize: '20px',
                        fontWeight: 100,
                        color: '#404040'
                    },
                },
                subtitle: {
                    style: {
                        fontWeight: 100
                    }
                },
                tooltip: {
                    theme: 'light',
                    x: {
                        show: false
                    },
                    y: {
                        title: {
                            formatter: function (categories) { return categories }
                        }
                    }
                }
            },
            series: [{
                data: []
            }],
        }
    }


    load() {

        const self = this;

        ajax.get(Constants.ROUTE_API_DASHBOARD_STAFF_CONTRIBUTION,
            {
                success: function (response) {     

                    let optionsCopy = Object.assign({}, self.state.options);
                    let seriesCopy = [...self.state.series];
                    let seriesUpdated = response.data.map(serie => serie.PERCENTAGE);
                    let labelsUpdated = response.data.map(label => label.STAFFNAME);

                    optionsCopy.xaxis.categories = labelsUpdated;
                    seriesCopy[0].data = seriesUpdated;

                    self.setState({
                        mode: Constants.MODE_LOADED,
                        options: optionsCopy,
                        series: seriesCopy
                    });
                }
            });
    }

    componentDidMount() {
        const self = this;
        self.load();
    }


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        return (
            <Fragment>
            <div className="chart-container">
              <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={320} />
            </div>
          </Fragment>	 
        )
    }
}



    

   
